import React, { useState, useEffect } from 'react'
import Login from './Components/LoginComponents/Login'
import MainComponent from './Components/MainComponent/MainComponent'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
//Redux
import { useDispatch } from 'react-redux'
import { userLogin } from './ReduxStore/Action/LoginAction'
import CancelRegistration from './Components/LoginComponents/CancelRegistration'
import PrivacyPolicy from './Components/LoginComponents/PrivacyPolicy'
import 'react-toastify/dist/ReactToastify.css'

// const App = () => {

//   const dispatch = useDispatch();

//   const [isUser, setIsUser] = useState(false);

//   const checkLogin = () => {
//     const logData = sessionStorage.getItem("digital-library")
//     //console.log(logData)

//     if (logData) {
//       const convLogData = JSON.parse(logData)
//       // console.log(convLogData.loginId + convLogData.password)
//       const dispatchLogData = {
//         loginId: convLogData.loginId,
//         password: convLogData.password
//       }
//       dispatch(userLogin(dispatchLogData))
//       setIsUser(true)
//     }
//     else {
//       setIsUser(false)
//     }
//   }

//   useEffect(() => {
//     checkLogin();
//   }, [])

//   return (
//     <>

//     <Routes>

//     <Route path="/cancel-member-page" element={<CancelRegistration />} />

//     <Route path="/privacy" element={<PrivacyPolicy />} />

//     </Routes>

//     {isUser ? (
//             <MainComponent setIsUser={setIsUser} />
//           ) : (
//             <Login setIsUser={setIsUser} />
//           )}
//     </>
//   )
// }

import { Navigate } from 'react-router-dom'
import ProtectedRoute from './ProtectedRoutes'
import { ToastContainer } from 'react-toastify'

const App = () => {
  const dispatch = useDispatch()
  const [isUser, setIsUser] = useState(null)

  useEffect(() => {
    const logData = sessionStorage.getItem('digital-library')

    if (logData) {
      const convLogData = JSON.parse(logData)
      dispatch(
        userLogin({
          loginId: convLogData.loginId,
          password: convLogData.password,
        }),
      )
      setIsUser(true)
    } else {
      setIsUser(false)
    }
  }, [])

  //  Block render until auth is known
  if (isUser === null) {
    return (
      <div
        style={{
          minHeight: '100vh',
          background: '#f5f5f5',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        Loading...
      </div>
    )
  }

  return (
    <>
       <ToastContainer />
    
    <Routes>
      {/* PUBLIC ROUTES */}
      <Route path="/login" element={<Login setIsUser={setIsUser} />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/cancel-member-page" element={<CancelRegistration />} />

      {/* PROTECTED ROUTES */}
      <Route
        path="/*"
        element={
          <ProtectedRoute isUser={isUser}>
            <MainComponent setIsUser={setIsUser} />
          </ProtectedRoute>
        }
      />

      {/* FALLBACK */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  )
}

export default App
